import React from 'react';
import { Box, Flex, useColorModeValue } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { BannerDivider } from '../../features/ev-charger/dashboard/banner-content/banner-cells';
import { formatDynamicDecimal } from '../../utils/common/common-utils';
import { DataCell } from './DataCell';

interface AdvancedChargingDetailsProps {
  power: number | null;
  maxAmps: number | null;
  chargingAmps: number | null;
}

function formatValue(value: number | null) {
  return value === null ? '—' : formatDynamicDecimal(Math.abs(value));
}

export function AdvancedChargingDetails({ power, maxAmps, chargingAmps }: AdvancedChargingDetailsProps) {
  const { t } = useTranslation();
  const borderColor = useColorModeValue('customGrey.200', 'customGrey.800');
  const textColor = useColorModeValue('gray.500', 'white');

  return (
    <Flex align="center" w="100%" color={textColor} data-testid="smartdevice-advanced-charging-details">
      <Box flex={1} textAlign="center" pr={2}>
        <DataCell
          value={formatValue(power)}
          suffix="kW"
          label={t('SmartDevice.current speed')}
          valueTestId="smartdevice-current-speed"
        />
      </Box>
      <BannerDivider borderColor={borderColor} />
      <Box flex={1} textAlign="center" px={2}>
        <DataCell
          value={formatValue(maxAmps)}
          suffix="A"
          label={t('SmartDevice.max amps')}
          valueTestId="smartdevice-max-amps"
        />
      </Box>
      <BannerDivider borderColor={borderColor} />
      <Box flex={1} textAlign="center" pl={2}>
        <DataCell
          value={formatValue(chargingAmps)}
          suffix="A"
          label={t('SmartDevice.charging amps')}
          valueTestId="smartdevice-charging-amps"
        />
      </Box>
    </Flex>
  );
}
